

/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

export const EMPTY_OBJECT = {};
